import {
    ProgramContainer, FormSections, FormSubSections,
    FormSectionElements, LOVValues,
    BaseType, BaseWithExtension, ShowDebugInfo, FormButtons, FormSubSectionFilter
}
    from '../entities/formTemplateDataType';
import Utils from './Utils';
import { filter } from 'lodash';

export default class Parser {
    static readonly showDebugInfo: boolean = ShowDebugInfo && false;
    static readonly showDebugInfoForSection: boolean = true;

    static readonly seporator: string = '/';
    static readonly basePath: string = '/UIElement';
    static readonly basePathReportBack: string = '/ListOfEgmsFormPublish/ProgramContainer';
    static readonly formSectionPath: string = 'ListOfFormSections/FormSections';
    static readonly formSubSectionPath: string = 'ListOfFormSubSections/FormSubSections';
    static readonly formSectionElementPath: string = 'ListOfFormSectionElements/FormSectionElements';
    static readonly formSectionElementLOVPath: string = 'ListOfLOVValues/LOVValues';
    static readonly formSectionElementSubSectionPath: string = 'FormSubSections';
    static readonly formButtonPath: string = 'Buttons/Button';
    
    static readonly formSubSectionFilterElementPath: string = 'Filter/FilterListOfFormSectionElements/FormSectionElements';
    static readonly formSubSectionFilterButtonPath: string = 'Filter/FilterButtons/Button';

    static formSectionsArray: FormSections[];

    static SequenceComparator(a: BaseType, b: BaseType): number {
        return (a.Sequence) - (b.Sequence);
    }

    static setProgramContainer(programContainer: ProgramContainer): ProgramContainer {
        let formTemplate: ProgramContainer = programContainer;
        
        return formTemplate;
    }

    // private static extractFormSections(sectionNodesArray: Node[]): FormSections[] {
    //     let formSectionsArray: FormSections[] = [];
    //     sectionNodesArray.forEach(sectionNode => {
    //         let title: string = Utils.getOneNode(sectionNode, 'ENUTitle');
    //         let formSections: FormSections = new FormSections();
    //         this.extractBase(sectionNode, formSections);

    //         let subSectionNodesArray: Node[] = Utils.getArray(sectionNode, this.formSubSectionPath);
    //         formSections.ListOfFormSubSections = this.extractFormSubSections(subSectionNodesArray, formSections);

    //         let buttonNodesArray: Node[] = Utils.getArray(sectionNode, this.formButtonPath);
    //         formSections.ListOfButtons = this.extractFormButtons(buttonNodesArray)
    //         formSections.ForRole = Utils.getOneNode(sectionNode, 'ForRole');
    //         formSections.EntityType = Utils.getOneNode(sectionNode, 'EntityType');
    //         formSections.ReferencedFormSectionID = Utils.getOneNode(sectionNode, 'ReferencedFormSectionID');
    //         // formSections.visible = this.existsVisibleChildren(formSections.ListOfFormSubSections);

    //         formSectionsArray.push(formSections);

    //     });

    //     this.formSectionsArray = formSectionsArray.sort(this.SequenceComparator);
    //     return this.formSectionsArray;
    // }

    static extractFormButtons(buttonNodesArray: Node[]) {
        let formSubSectionsArray: FormButtons[] = [];
        buttonNodesArray.forEach(buttonNode => {
            let formButton: FormButtons = new FormButtons();

            formButton.Label = Utils.getOneNode(buttonNode, 'Label');
            formButton.Status = Utils.getOneNode(buttonNode, 'Status');
            formButton.Api = Utils.getOneNode(buttonNode, 'Api');
            formButton.Icon = Utils.getOneNode(buttonNode, 'Icon');
            formButton.Script = Utils.getOneNode(buttonNode, 'Script');
            formButton.VisibleStatus = Utils.getOneNode(buttonNode, 'VisibleStatus');
            formButton.ForRole = Utils.getOneNode(buttonNode, 'ForRole');
            formButton.BackButton = Utils.getOneNode(buttonNode, 'BackButton');
            formSubSectionsArray.push(formButton);
        }
        );

        return formSubSectionsArray;
    }

    public static updateSubSection(subSection: FormSubSections): FormSections[] {
        this.formSectionsArray.forEach((e) => {
   
            let ele = e.ListOfFormSubSections.filter(p => p.Id = subSection.Id)[0];
            if (ele != null) {
     
                ele = subSection;
     
            }

        });

        return this.formSectionsArray;
    }

    // private static extractFormSubSections(subSectionNodesArray: Node[], formSections: FormSections): FormSubSections[] {
    //     let formSubSectionsArray: FormSubSections[] = [];
    //     subSectionNodesArray.forEach(subSectionNode => {
    //         let subSection: FormSubSections = new FormSubSections();
    //         this.extractBase(subSectionNode, subSection);
    //         subSection.parent = formSections;
    //         subSection.SectionId = Utils.getOneNode(subSectionNode, 'SectionId');
    //         subSection.RoleHasAddbutton = Utils.getOneNode(subSectionNode, 'RoleHasAddbutton');
    //         subSection.HasPopup=Utils.getOneNode(subSectionNode, 'HasPopup');
    //         subSection.ButtonLabel = Utils.getOneNode(subSectionNode, 'ButtonLabel');
    //         subSection.EntityType = Utils.getOneNode(subSectionNode, 'EntityType');
    //         subSection.ForRole = Utils.getOneNode(subSectionNode, 'ForRole');
    //         subSection.WithinTab = Utils.getOneNode(subSectionNode, 'WithinTab');
    //         subSection.Datasource = Utils.getOneNode(subSectionNode, 'Datasource');
    //         subSection.Api = Utils.getOneNode(subSectionNode, 'Api');
    //         subSection.OrderBy = Utils.getOneNode(subSectionNode, 'OrderBy');
    //         subSection.EditableStatus = Utils.getOneNode(subSectionNode, 'EditableStatus');
    //         subSection.Paging = Utils.getOneNode(subSectionNode, 'Paging');
    //         subSection.OwnerEditableOnly = Utils.getOneNode(subSectionNode, 'OwnerEditableOnly');
    //         let elementsNodesArray: Node[] = Utils.getArray(subSectionNode, this.formSectionElementPath);
    //         let sectionElements = this.extractSectionElements(elementsNodesArray, subSection);
    //         subSection.ListOfFormSectionElements = sectionElements;

    //         let elementsNodesArrayFilter: Node[] = Utils.getArray(subSectionNode, this.formSubSectionFilterElementPath);
    //         let sectionElementsFilter = this.extractSectionElements(elementsNodesArrayFilter, subSection);
    //      //  subSection.FilterListOfFormSectionElements = sectionElementsFilter;

    //         let buttonsNodesArrayFilter: Node[] = Utils.getArray(subSectionNode, this.formSubSectionFilterButtonPath);
    //         let sectionButtonsFilter = this.extractFormButtons(buttonsNodesArrayFilter);
    //     //    subSection.FilterListOfFormSectionButtons = sectionButtonsFilter;

    //         // subSection.visible = true;
    //         formSubSectionsArray.push(subSection);
    //     });

    //     return formSubSectionsArray.sort(this.SequenceComparator);
    // }


    private static extractFieldFormSubSections(subSectionNodesArray: Node[], ele: FormSectionElements): FormSubSections[] {
        let formSubSectionsArray: FormSubSections[] = [];
        subSectionNodesArray.forEach(subSectionNode => {
            let subSection: FormSubSections = new FormSubSections();
            this.extractBase(subSectionNode, subSection);
            subSection.parent = ele;
            subSection.SectionId = Utils.getOneNode(subSectionNode, 'SectionId');
            subSection.RoleHasAddbutton = Utils.getOneNode(subSectionNode, 'RoleHasAddbutton');
            subSection.HasPopup = Utils.getOneNode(subSectionNode, 'HasPopup');
            subSection.ButtonLabel = Utils.getOneNode(subSectionNode, 'ButtonLabel');
            subSection.WithinTab = Utils.getOneNode(subSectionNode, 'WithinTab');
            subSection.Datasource =  Utils.getOneNode(subSectionNode, 'Datasource');
            subSection.Api = Utils.getOneNode(subSectionNode, 'Api');
            subSection.ForRole = Utils.getOneNode(subSectionNode, 'ForRole');
            subSection.RecordType = Utils.getOneNode(subSectionNode, 'RecordType');
            let elementsNodesArray: Node[] = Utils.getArray(subSectionNode, this.formSectionElementPath);
            let sectionElements = this.extractSectionElements(elementsNodesArray, subSection);
            subSection.ListOfFormSectionElements = sectionElements; 
            
            let elementsNodesArrayFilter = Utils.getArray(subSectionNode, this.formSubSectionFilterElementPath);
            let sectionElementsFilter = this.extractSectionElements(elementsNodesArrayFilter, subSection);
       //     subSection.FilterListOfFormSectionElements=sectionElementsFilter;
        
            // subSection.visible = true;
            // this.existsVisibleChildren(subSection.ListOfFormSectionElements);

            formSubSectionsArray.push(subSection);
        });

        return formSubSectionsArray.sort(this.SequenceComparator);
    }


    private static extractSectionElements(elementsNodesArray: Node[], subSection: FormSubSections): FormSectionElements[] {
        let sectionElementsArray: FormSectionElements[] = [];
        let fundingItemColumnCount: number = 0;

        elementsNodesArray.forEach(elementNode => {
           
                let sectionElement: FormSectionElements = new FormSectionElements();
             
                this.extractBase(elementNode, sectionElement);
                if (sectionElement.ENUTitle === 'Funding Item*') {
                    fundingItemColumnCount += 1;

                    if (fundingItemColumnCount > 1) {
                        return;
                    }
                }

                sectionElement.parent = subSection;
                sectionElement.StaticDropdownReference = Utils.getOneNode(elementNode, 'StaticDropdownReference');
                // sectionElement.EntityType = Utils.getOneNode(elementNode, 'EntityType');
                sectionElement.OnOff = Utils.getOneNode(elementNode, 'OnOff');
                sectionElement.LoadBindName = Utils.getOneNode(elementNode, 'LoadBindName');
                sectionElement.LoadBindBase = Utils.getOneNode(elementNode, 'LoadBindBase');
                sectionElement.Datatype = Utils.getOneNode(elementNode, 'Datatype');
            
                sectionElement.Editable = Utils.getOneNode(elementNode, 'Editable');
                sectionElement.Length = Utils.getOneNode(elementNode, 'Length'); 
                sectionElement.Optional = Utils.getOneNode(elementNode, 'Optional');
                sectionElement.RecordName = Utils.getOneNode(elementNode, 'RecordName');

                sectionElement.SubSectionId = Utils.getOneNode(elementNode, 'SubSectionId');
                sectionElement.TooltipENU = Utils.getOneNode(elementNode, 'TooltipENU');
                sectionElement.TooltipFRA = Utils.getOneNode(elementNode, 'TooltipFRA');
                sectionElement.Type = Utils.getOneNode(elementNode, 'Type');
                sectionElement.Value = Utils.getOneNode(elementNode, 'Value');
                sectionElement.ENUValidateTitle = Utils.getOneNode(elementNode, 'ENUValidateTitle');
                sectionElement.FRAValidateTitle = Utils.getOneNode(elementNode, 'FRAValidateTitle');
                sectionElement.Language = Utils.getOneNode(elementNode, 'Language');
                sectionElement.Api = Utils.getOneNode(elementNode, 'Api');
                sectionElement.FilterField = Utils.getOneNode(elementNode, 'FilterField');
                sectionElement.FilterCompareMethod = Utils.getOneNode(elementNode, 'FilterCompareMethod');
                sectionElement.ValidateCompareMethod = Utils.getOneNode(elementNode, 'ValidateCompareMethod');
                sectionElement.ValidateCompareField = Utils.getOneNode(elementNode, 'ValueType');
                sectionElement.ValueType=Utils.getOneNode(elementNode, 'ValidateCpmpareField');
                sectionElement.DecidingField1=Utils.getOneNode(elementNode, 'DecidingField1');
                sectionElement.CalculationMethod=Utils.getOneNode(elementNode, 'CalculationMethod');
                sectionElement.DecidingField2=Utils.getOneNode(elementNode, 'DecidingField2');
                sectionElement.MeasurementUnit=Utils.getOneNode(elementNode, 'MeasurementUnit');
                sectionElement.HasSummaryRow=Utils.getOneNode(elementNode, 'HasSummaryRow');
                sectionElement.HasTotalColumn=Utils.getOneNode(elementNode, 'HasTotalColumn');
                sectionElement.FreezeColumn=Utils.getOneNode(elementNode, 'FreezeColumn');

                sectionElement.HasGrandTotal=Utils.getOneNode(elementNode, 'HasGrandTotal');        
                sectionElement.FilterValue = Utils.getOneNode(elementNode, 'FilterValue');
                sectionElement.ForRole = Utils.getOneNode(elementNode, 'ForRole');
                sectionElement.EGMSStyle=Utils.getOneNode(elementNode, 'EGMSStyle');
                sectionElement.counterVisible= Utils.getOneNode(elementNode, 'counterVisible')=='true';
                sectionElement.HasAddButton=Utils.getOneNode(elementNode, 'HasAddButton');
                sectionElement.DisplayTooltipValue=Utils.getOneNode(elementNode, 'DisplayTooltipValue');
                sectionElement.Script=Utils.getOneNode(elementNode, 'Script');
                sectionElement.ScriptTriggerField=Utils.getOneNode(elementNode, 'ScriptTriggerField');
                sectionElement.ScriptTriggerFieldValue=Utils.getOneNode(elementNode, 'ScriptTriggerFieldValue');
                sectionElement.AffectedField=Utils.getOneNode(elementNode, 'AffectedField');
                sectionElement.EnabledByField=Utils.getOneNode(elementNode, 'EnabledByField');
                sectionElement.EnabledByFieldValue=Utils.getOneNode(elementNode, 'EnabledByFieldValue');
                sectionElement.Hint=Utils.getOneNode(elementNode, 'Hint');
                sectionElement.HintFR=Utils.getOneNode(elementNode, 'HintFR');
                sectionElement.UpdateField=Utils.getOneNode(elementNode, 'UpdateField');
                sectionElement.HintFR=Utils.getOneNode(elementNode, 'colWidth');
                sectionElement.filterDisplay=Utils.getOneNode(elementNode, 'filterDisplay');
                sectionElement.ErrorMessage=Utils.getOneNode(elementNode, 'ErrorMessage');
                let subSectionNodeList: Node[] = Utils.getArray(elementNode, this.formSectionElementSubSectionPath);
                if(subSectionNodeList!=null && subSectionNodeList.length>0){
                    let subSections= this.extractFieldFormSubSections(subSectionNodeList,sectionElement);
                    sectionElement.subSectionList=subSections;
                }
               
                sectionElement.ListOfLOVValues = this.extractSectionElementsLOVs(
                    Utils.getArray(elementNode, this.formSectionElementLOVPath)
                );
                // sectionElement.visible = true;
                // sectionElement.labelVisible = !this.isTitleOffByStyle(sectionElement.EGMSStyle);

                // sectionElement.valueAsLabel = (sectionElement.Datatype === 'Text' && sectionElement.Editable === 'N'
                //     && sectionElement.Value !== '');

                sectionElementsArray.push(sectionElement);
        });

        return sectionElementsArray.sort(this.SequenceComparator);
    }

    private static isTitleOffByStyle(styleString: string): boolean {
        return (styleString && styleString.indexOf('title-position : none;') >= 0);
    }

    private static extractSectionElementsLOVs(lovNodesArray: Node[]): LOVValues[] {
        let lovArray: LOVValues[] = [];
        lovNodesArray.forEach(lovNode => {
            let lov = new LOVValues();
            lov.code = Utils.getOneNode(lovNode, 'ENU');
            lov.FRA = Utils.getOneNode(lovNode, 'FRA');
            lov.description = Utils.getOneNode(lovNode, 'ENUDescription');
            lov.FRADescription = Utils.getOneNode(lovNode, 'FRADescription');
            lov.FilterField = Utils.getOneNode(lovNode, 'FilterField');
            lov.FilterValue = Utils.getOneNode(lovNode, 'FilterValue');

            lovArray.push(lov);
        });
        return lovArray;
    }

    private static existsVisibleChildren(children: BaseType[]): boolean {
        if (children.length === 0) {
            return false;
        }
        for (var i = 0; i <= children.length; i++) {
            if (children[i]) {
                return true;
            }
        }
        return false;
    }

    private static extractBase(theNode: Node, theType: BaseType): void {
        theType.Id = Utils.getOneNode(theNode, 'Id');
        theType.ENUTitle = Utils.stripLineBreaks(Utils.getOneNode(theNode, 'ENUTitle'));
        theType.ENUDescription = Utils.stripLineBreaks(Utils.getOneNode(theNode, 'ENUDescription'));
        theType.FRATitle = Utils.stripLineBreaks(Utils.getOneNode(theNode, 'FRATitle'));
        theType.FRADescription = Utils.stripLineBreaks(Utils.getOneNode(theNode, 'FRADescription'));
        theType.RecordType = Utils.getOneNode(theNode, 'RecordType');
        theType.Sequence = parseFloat(Utils.getOneNode(theNode, 'Sequence'));
       
    }

    static extractFormSectionElement(loadBindBase: string, loadBindName: string): FormSectionElements[] {
        let elementsFound: FormSectionElements;

        if (this.formSectionsArray == null)
           return null;

        let detailSectionList = this.formSectionsArray;
        let foundElementList = [];
        for (let i = 0; i < detailSectionList.length; i++) {
            let formSection: FormSections = detailSectionList[i];
            for (let j = 0; j < formSection.ListOfFormSubSections.length; j++) {
                let section: FormSubSections = formSection.ListOfFormSubSections[j];
                
                let elements
                if (loadBindBase == null) {
                    elements = section.ListOfFormSectionElements.find(element => (element.LoadBindBase == '' || element.LoadBindBase == null)&& element.LoadBindName == loadBindName);
                } else {
                    elements = section.ListOfFormSectionElements.find(element => element.LoadBindBase == loadBindBase && element.LoadBindName == loadBindName);
                }
                if (elements) {
                    elementsFound = elements;
                    foundElementList.push(elementsFound);
                    break;
                }
            }
            // if (elementsFound) {
            //     break;
            // }
        }

        return foundElementList;
    }

    static findSectionElement(ele: FormSectionElements, bindName: string) {
        //let subSection = ele.parent as FormSubSections;
        //let section = subSection.parent as FormSections;
        let section = ele.parent.parent.Datatype==='Row'?ele.parent.parent.parent.parent : ele.parent.parent as FormSections;
        for (let subSection of section.ListOfFormSubSections) {
            for (let ele of subSection.ListOfFormSectionElements) {
                if(ele.Datatype==='Row'&&ele.subSectionList){
                    ele.subSectionList[0].ListOfFormSectionElements.forEach(el=>{
                        if (el.LoadBindName == bindName) {
                            return el;
                        }
                    })
                }else if (ele.LoadBindName == bindName && !subSection.ReadOnlyElements) {
                    return ele;
                }
            }
        }
        return null;
    }

    static findSubSectionElement(ele: FormSectionElements, bindName: string) {
        let subSection = ele.parent as FormSubSections;
        for (let ele of subSection.ListOfFormSectionElements) {
            if (ele.LoadBindName == bindName) {
                return ele;
            }
        }
        return null;
    }

    static extractFormSectionElementInSubSection(loadBindName: string, subSection: FormSubSections): FormSectionElements[] {
        let elements;//= subSection.FilterListOfFormSectionElements.filter(element=> element.LoadBindName == loadBindName);
        return elements;
    }

    static extractspecificFormSection(recordType:string) {
        
        let formSectionList= this.formSectionsArray.filter(formSection =>formSection.RecordType==recordType);
       
        if (formSectionList.length > 0) {
            return formSectionList[0];
        }

        return null;
    }

    static extractRoleBasedFormSection(forRole:string, entityType?:string) {
        let formSectionList
        if(typeof entityType=='undefined'){
           formSectionList= this.formSectionsArray.filter(formSection =>{formSection.ForRole && formSection.ForRole.indexOf(forRole)>-1});
        } else {
            formSectionList= this.formSectionsArray.filter(formSection => formSection.ForRole &&formSection.ForRole.indexOf(forRole)>-1 && formSection.EntityType==entityType);
        }
    
        if (formSectionList.length > 0) {
            return formSectionList[0];
        }

        return null;
    }

    static extractDetailsSections(){
        const detailsSectionList = this.formSectionsArray.filter(formSection => formSection.RecordType == 'Detail');

        return detailsSectionList;
    }

    static extractSectionById(id: string ){
        const detailsSection = this.formSectionsArray.filter(formSection => formSection.Id == id);
        return detailsSection;
    }

    static extractElementWithFilterField(){
        const detailsSectionList = this.formSectionsArray.filter(formSection => formSection.RecordType == 'Detail');
        detailsSectionList.forEach((formSection)=>{
            formSection.ListOfFormSubSections.filter((subSection)=>{
                subSection.ListOfFormSectionElements.forEach((ele)=>{
                    if(ele.ListOfLOVValues.length>0){
                        ele.ListOfLOVValues.forEach(lov=>{
                         
                        })
                    }
                })
            })
        })
    }
}


